import { Component, Emit, Ref, Vue } from 'vue-property-decorator'
import ValuableConceptsModalComponent from '@/components/valuable-concepts-modal/valuable-concepts-modal.vue'
import ValuableConceptsModal from '@/components/valuable-concepts-modal/valuable-concepts-modal'
import { BillingCaseResponse } from '@/api/services/billing/case-grid/billing-case.dto'
import { AppliedBillableConceptEntityType } from '@/api/services/billing/applied-billable-concept/billing-applied-billable-concept.dto'
import { BillingStoreHelper } from '@/modules/billing-module/store/billing-store.helper'
import { MenuItemDef } from '@ag-grid-enterprise/all-modules'
import { billingCaseService } from '@/api/services/billing/case-grid/billing-case.service'
import { EntityIdentifiersRequest } from '@/shared/models/http/http.model'
import { StrictNullable } from '@/shared/types/app.types'
import { store } from '@/store/store'
import { PromiseUtils } from '@/shared/util/promise-utils'
import { ToastUtils } from '@/shared/util/toast-utils'
import { HelperUtils } from '@/shared/util/helper-utils'
import { BillingOperation } from '@/api/operations/models/billing-operation'

@Component({
    components: {
        ValuableConceptsModalComponent
    }
})
export default class BillingGridActionsCases extends Vue {
    @Ref() readonly conceptsModal!: ValuableConceptsModal

    @Emit()
    refresh(): void {
        // emits an event
    }

    private static get _masterSelectedRows(): BillingCaseResponse[] {
        return BillingStoreHelper.masterSelectedRows as BillingCaseResponse[]
    }
    private static get _masterSelectedRow(): StrictNullable<BillingCaseResponse> {
        return BillingGridActionsCases._masterSelectedRows.length === 1
            ? BillingGridActionsCases._masterSelectedRows[0]
            : null
    }

    get canShowConceptsModal(): boolean {
        return BillingGridActionsCases._masterSelectedRows.length === 1 &&
            HelperUtils.hasOperationInCurrentLaboratory(BillingOperation.MANAGE_APPLIED_CONCEPTS)
    }
    get canDeleteAutomaticBillableConflict(): boolean {
        return !!BillingGridActionsCases._masterSelectedRows.length
    }

    /// SERVICE CALLS ///

    private async _deleteAutomaticBillableConflicts(entityIdentifiers: number[]): Promise<void> {
        const request: EntityIdentifiersRequest = { entityIdentifiers }
        const response =
            await PromiseUtils.toCallSecure(
                billingCaseService.deleteAutomaticBillableConflicts(
                    store.state.labId,
                    request))
        if (response !== null) {
            ToastUtils.showToastSuccess(this.$tc('accounting.case.deleteAutomaticBillableConflicts'))
            this.refresh() // emits an event
        }
    }

    /// EVENT HANDLERS ///

    onShowConceptsModal(): void {
        if (BillingGridActionsCases._masterSelectedRow) {
            this.conceptsModal.show({
                isBillingModule: true,
                caseId: BillingGridActionsCases._masterSelectedRow.id,
                entityConcept: {
                    entityId: BillingGridActionsCases._masterSelectedRow.id,
                    entityType: AppliedBillableConceptEntityType.CASE
                }
            })
        }
    }

    async onDeleteAutomaticBillableConflict(): Promise<void> {
        const caseIds = BillingGridActionsCases._masterSelectedRows.map(selectedRow => selectedRow.id)
        await this._deleteAutomaticBillableConflicts(caseIds)
    }

    ///

    getContextMenuItems(): MenuItemDef[] {
        const menuItems: MenuItemDef[] = []
        if (this.canShowConceptsModal) {
            menuItems.push({
                name: this.$tc('accounting.action.concepts'),
                action: this.onShowConceptsModal
            })
        }
        if (this.canDeleteAutomaticBillableConflict) {
            menuItems.push({
                name: this.$tc('accounting.action.uncheckAutomationError'),
                action: this.onDeleteAutomaticBillableConflict
            })
        }
        return menuItems
    }
}
